import { Config } from "../../../core/config/config";

export function getUbbleRedirectUrl() {
  return Config.UBBLE_REDIRECT_WEB_CLIENT_SCHEME;
}

export function getUbbleRedirectUrlNewOnboarding() {
  return Config.UBBLE_REDIRECT_NEW_ONBOARDING_WEB_CLIENT_URL;
}
